import React from 'react'
import { useTranslation } from 'react-i18next'

export default function FiltersBar({ value, onChange }){
  const { t } = useTranslation()
  const v = value
  const update = (patch) => onChange({ ...v, ...patch })

  return (
    <div className="card mb-6">
      <div className="grid lg:grid-cols-7 gap-3">
        {/* Ville */}
        <input
          className="px-3 py-2 rounded-xl border border-blue-100"
          placeholder={t('filters.city')}
          value={v.city || ''}
          onChange={e=>update({ city: e.target.value })}
        />

        {/* Dates */}
        <input
          type="date"
          className="px-3 py-2 rounded-xl border border-blue-100"
          value={v.checkin || ''}
          onChange={e=>update({ checkin: e.target.value })}
          aria-label={t('filters.checkin')}
          title={t('filters.checkin')}
        />
        <input
          type="date"
          className="px-3 py-2 rounded-xl border border-blue-100"
          value={v.checkout || ''}
          onChange={e=>update({ checkout: e.target.value })}
          aria-label={t('filters.checkout')}
          title={t('filters.checkout')}
        />

        {/* Catégorie */}
        <select
          className="px-3 py-2 rounded-xl border border-blue-100"
          value={v.category || ''}
          onChange={e=>update({ category: e.target.value || null })}
        >
          <option value="">{t('filters.anyCategory')}</option>
          <option value="hotel">{t('categories.hotel')}</option>
          <option value="appartement">{t('categories.appartement')}</option>
          <option value="maison_meublee">{t('categories.maison_meublee')}</option>
          <option value="studio">{t('categories.studio')}</option>
          <option value="villa">{t('categories.villa')}</option>
          <option value="ForRent">{t('categories.ForRent')}</option>
          <option value="TwoRoom">{t('categories.TwoRoom')}</option>
          <option value="House">{t('categories.House')}</option>
          <option value="SharedRoom">{t('categories.SharedRoom')}</option>
          <option value="Parking">{t('categories.Parking')}</option>
        </select>

        {/* Prix min */}
        <div className="flex items-center gap-2 px-3 py-2 rounded-xl border border-blue-100">
          <span className="text-sm whitespace-nowrap">{t('filters.minPrice')}</span>
          <input
            type="number"
            min={0}
            className="w-24 px-2 py-1 rounded-md border border-blue-100"
            placeholder="0"
            value={v.minPrice ?? ''}
            onChange={(e)=>update({ minPrice: e.target.value === '' ? '' : Number(e.target.value) })}
          />
        </div>

        {/* Prix max */}
        <div className="flex items-center gap-2 px-3 py-2 rounded-xl border border-blue-100">
          <span className="text-sm whitespace-nowrap">{t('filters.maxPrice')}</span>
          <input
            type="number"
            min={0}
            className="w-24 px-2 py-1 rounded-md border border-blue-100"
            placeholder="∞"
            value={v.maxPrice ?? ''}
            onChange={(e)=>update({ maxPrice: e.target.value === '' ? '' : Number(e.target.value) })}
          />
        </div>

        {/* Devise */}
        <select
          className="px-3 py-2 rounded-xl border border-blue-100"
          value={v.currency || 'XAF'}
          onChange={e=>update({ currency: e.target.value })}
          title={t('filters.currency')}
          aria-label={t('filters.currency')}
        >
          <option value="XAF">XAF</option>
          <option value="EUR">EUR</option>
        </select>

        {/* Meublé */}
        <label className="inline-flex items-center gap-2 px-3 py-2 rounded-xl border border-blue-100">
          <input
            type="checkbox"
            checked={!!v.furnished}
            onChange={e=>update({ furnished: e.target.checked })}
          />
          {t('filters.furnished')}
        </label>
      </div>

      {/* Guests */}
      <div className="grid md:grid-cols-3 gap-3 mt-3">
        <NumberField
          label={t('filters.adults')}
          min={0}
          value={v.adults ?? 1}
          onChange={(n)=>update({ adults: n })}
        />
        <NumberField
          label={t('filters.children')}
          min={0}
          value={v.children ?? 0}
          onChange={(n)=>update({ children: n })}
        />
        <NumberField
          label={t('filters.infants')}
          min={0}
          value={v.infants ?? 0}
          onChange={(n)=>update({ infants: n })}
        />
      </div>
    </div>
  )
}

function NumberField({ label, value, onChange, min=0 }){
  return (
    <div className="flex items-center justify-between px-3 py-2 rounded-xl border border-blue-100">
      <span className="font-medium">{label}</span>
      <div className="flex items-center gap-2">
        <button type="button" className="px-2 py-1 rounded-lg border" onClick={()=>onChange(Math.max(min, (value||0)-1))}>−</button>
        <input
          type="number"
          min={min}
          className="w-16 text-center border rounded-md"
          value={value}
          onChange={(e)=>onChange(Number(e.target.value))}
        />
        <button type="button" className="px-2 py-1 rounded-lg border" onClick={()=>onChange((value||0)+1)}>+</button>
      </div>
    </div>
  )
}
